/** LIBRARIES */
// @ts-nocheck
import { validation, changeQuestion, tryAgain, setAudioOptions } from "./functions"
import { optionSelect } from "./optionSelect"
import "./interfaces";
import { dama } from "./../../../../modules/dama"
/** OBJECTS */
import objectDataTrivia from "./objects";
declare global {
	interface Window {
	  drupalSettings: any;
	}
}

const pathMedia = `/themes/custom/do_presidente_theme`

let triviaClass: string = "trivia";
let refTriviaList = document.querySelectorAll(`.${triviaClass}`) as any;

let outputData: string = "data-op";

const dm = new dama()

// ---------------- TRIVIA MODULE ----------------
export const StartTrivia = () => {
	if (refTriviaList.length > 0) [...refTriviaList].forEach((trivia: any) => __setControllerByTrivia(trivia))
};

/**
 * 
 * this constroller goint to config the information by trivia, setting buttons, tryAgian and audios.
 * 
 * @param refTrivia 
 * 
 */

function __setControllerByTrivia(refTrivia: Element): void {
	let trivia: Quiz = {
		...objectDataTrivia,
		htmlReferences: {
			time: document.querySelector(`#finishedTrivia [${outputData}-time]`),
			points: document.querySelector(`#finishedTrivia [${outputData}-points]`),
			totalQuestions: refTrivia.querySelector(`[${outputData}-questions]`),
			correctAnswers: document.querySelector(`#finishedTrivia [${outputData}-responses]`),
			nextButton: refTrivia.querySelector(`.${triviaClass}__next-btn`),
		},
	};

	if (trivia.htmlReferences.nextButton) {
		let {
			nextButton
		} = trivia.htmlReferences;
		let soundNext = document.createElement("audio");
		//${window.drupalSettings.path.themeUrl}

		soundNext.src = `${window.drupalSettings.path.themeUrl}/sources/dist/audio/clic.mp3`;
		soundNext.preload = "metadata";
		soundNext.volume = 0.5;

		let errorSound = document.createElement("audio");
		errorSound.src = `${window.drupalSettings.path.themeUrl}/sources/dist/audio/lose.mp3`;
		errorSound.preload = "metadata";
		clickNextQuestion(nextButton, soundNext, refTrivia, trivia)
	}
	tryAgain(refTrivia, trivia, triviaClass, pathMedia);

	setAudioOptions(refTrivia, pathMedia);
}

function clickNextQuestion(nextButton: any, soundNext: any, refTrivia: any, trivia: any): void {
	nextButton.addEventListener("click", async (e: any) => {
		const request = await validation(refTrivia, trivia, triviaClass);
		if (request.state) {
			soundNext.play();
			changeQuestion(refTrivia, trivia, triviaClass, pathMedia);
			optionSelect();
		}
		dm.print('error', !request.state ? request.output : '')
	});
}